import { createEntityAdapter, EntityState } from '@reduxjs/toolkit';
import { on, reducer } from 'ts-action';
import * as undoActions from '../../undo/actions/undo.actions';
import * as cellActions from '../actions/cell.actions';
import { Cell } from '../types/cell.type';

export type CellState = EntityState<Cell>;

declare module 'react-redux' {
  interface DefaultRootState {
    cell: CellState;
  }
}

const cellAdapter = createEntityAdapter<Cell>();

export const { selectAll, selectById } = cellAdapter.getSelectors();

export default reducer(
  cellAdapter.getInitialState(),
  on(cellActions.register, (state, { cell }) =>
    cellAdapter.upsertOne(state, cell),
  ),
  on(cellActions.unregister, (state, { cellId }) =>
    cellAdapter.removeOne(state, cellId),
  ),
  on(undoActions.undo, undoActions.restore, (state, { diff: { cell } }) => {
    if (!cell) {
      return state;
    }
    return { ...state, ...cell };
  }),
);
